import type {
  TypedSchemaInput,
  TypedSchemaOutput,
} from "@/utils/typeUtilities"
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import z from "zod"
import { trimmedString } from "@/forms/validation/stringFieldSchemas"

const orderItemFormSchema = z.object({
  note: trimmedString(),
  quantity: z.number(),
  modifiers: z.array(
    z.object({
      id: z.string(),
      groupId: z.string(),
      label: z.string(),
      priceOffset: z.number(),
    })
  ),
})

export type OrderItemFormInput = TypedSchemaInput<
  typeof orderItemFormSchema
>

export type OrderItemFormOutput = TypedSchemaOutput<
  typeof orderItemFormSchema
>

export const useOrderItemForm = (
  initialValues: OrderItemFormInput
) =>
  useForm({
    validationSchema: toTypedSchema(orderItemFormSchema),
    initialValues: initialValues,
  })
